import {ReactNode} from 'react';

import {UserRoles} from './auth';

export enum PackageTypes {
    PACK = 'PACK',
    CARTON = 'CARTON',
    BOX = 'BOX',
    PALLET = 'PALLET',
    PRIMARY_PACKAGING = 'PRIMARY_PACKAGING',
    TRANSPORT_PACKAGING = 'TRANSPORT_PACKAGING',
    UNIT = 'UNIT',
    CONTAINER = 'CONTAINER',
    GROUP = 'GROUP',
    CUSTOMS_UNIT = 'CUSTOMS_UNIT',
}

export const statuses = {
    ACTIVE: true,
    INACTIVE: false,
};

export const CUSTOMER_PACKAGE_TYPES = [PackageTypes.UNIT, PackageTypes.GROUP];
export const TRANSPORT_PACKAGE_TYPES = [
    PackageTypes.PALLET,
    PackageTypes.BOX,
    PackageTypes.CONTAINER,
];

export enum OutdatedPackageTypes {
    PACK = 'PACK',
    CARTON = 'CARTON',
    PRIMARY_PACKAGING = 'PRIMARY_PACKAGING',
    TRANSPORT_PACKAGING = 'TRANSPORT_PACKAGING',
}

export enum ProductStatuses {
    PENDING = 'PENDING',
    PUBLISHED = 'PUBLISHED',
}

export const getAvailableProductStatuses = (role?: UserRoles): Record<string, string> => {
    const allStatuses = {
        PENDING: ProductStatuses.PENDING,
        PUBLISHED: ProductStatuses.PUBLISHED,
    };

    if (role === UserRoles.ROLE_MPL_OPERATOR_ADMIN) {
        return allStatuses;
    }

    return {
        PENDING: ProductStatuses.PENDING,
    };
};

export enum PackagingType {
    PACKAGE = 'PACKAGE',
    BLISTER = 'BLISTER',
    BOX = 'BOX',
    CARTON = 'CARTON',
    PACKAGING = 'PACKAGING',
    VESSEL = 'VESSEL',
}

export enum GtinStatuses {
    PUBLISHED = 'PUBLISHED',
    PENDING = 'PENDING',
}

export enum ActiveStatuses {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export enum GtinsAccessors {
    name = 'productName',
    gtin = 'gtin',
    brand = 'productTrademark',
    manufacturer = 'manufacturerName',
    productGroupCode = 'productGroupCode',
    packageType = 'packageType',
    status = 'status',
    isActive = 'isActive',
}

export interface GtinsGridRawRow {
    productName: string;
    gtin: string;
    productTrademark: string;
    manufacturerName: string;
    productGroupCode: string;
    packageType: string;
    isActive: boolean;
    status: string;
}

export interface GtinsGridFormattedRow {
    [GtinsAccessors.name]: string;
    [GtinsAccessors.gtin]: string;
    [GtinsAccessors.brand]: string;
    [GtinsAccessors.manufacturer]: string;
    [GtinsAccessors.productGroupCode]: ReactNode;
    [GtinsAccessors.packageType]: string;
    [GtinsAccessors.status]: string;
    [GtinsAccessors.isActive]: boolean;
}

export interface GtinUploadDataItem {
    gtin?: string;
    name?: string;
    vendorCode?: string;
    trademark?: string;
    manufacturerId?: string;
    productId?: string;
}

export interface GtinOrderListItem {
    gtin: string;
    manufacturerName: string;
    productName: string;
    productVendorCode: string;
    productTrademark: string;
    manufacturerId: number;
    productGroupCode: string;
    packageType: PackageTypes;
}

export interface PackagingFormatType {
    name: string;
    nameEn: string;
    nameFr: string;
}

export interface Country {
    code: string;
    country: string;
    countryFr: string;
}
